import { useSelector } from 'react-redux'

import { selectIntegrationSettingsByProvider } from 'ducks/integrations'
import IntegrationExternalAction, {
  shouldShowIntegrationAction,
  getActionFromMxEvent,
} from 'components/App/DesktopView/Layout/TicketInspector/Changesets/ExpandedMessage/IntegrationExternalAction'
import IntegrationEventWrapper from './Wrapper'

export default function IntegrationEventExternal({ mxEvent }) {
  const integrationSettings = useSelector(selectIntegrationSettingsByProvider)
  const isShadow = mxEvent.getContent().msgtype === 'g.shadow'
  if (isShadow) return null
  const action = getActionFromMxEvent(mxEvent)

  if (shouldShowIntegrationAction(action, integrationSettings))
    return (
      <IntegrationEventWrapper provider={action.change?.provider}>
        {'  '}
        <IntegrationExternalAction action={action} />
      </IntegrationEventWrapper>
    )
  return null
}
